import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';

import { SecondaryButton } from '../_core/_ui/buttons.component';
import { IntlMsg } from '../_core/IntlMsg/intl-msg.component';
import { IParentPlayerCoContact } from '../../lib/types';
import { otherContactsMessages as messages } from './player-contact.messages';
import { ContactSummaryList } from './contact-summary-list.component';

interface IOtherContactsDisclosureProps {
  contacts: IParentPlayerCoContact[];
  // Scopes the aria-controls id when several disclosures share a page.
  id: string;
}

// Collapsed by default — for most parents this list is information they never
// need, so it stays one tap away rather than occupying the page.
export const OtherContactsDisclosure: React.FC<IOtherContactsDisclosureProps> = ({ contacts, id }) => {
  const [open, setOpen] = useState(false);
  const listId = `other-contacts-${id}`;

  // Nobody else on the athlete is a non-event, not a state worth announcing.
  if (contacts.length === 0) return null;

  return (
    <Box mt={1}>
      <SecondaryButton
        variant="text"
        size="small"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-controls={listId}
        startIcon={<PeopleOutlineIcon fontSize="small" />}
        endIcon={open ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
      >
        {open
          ? <IntlMsg {...messages.otherContactsHide} />
          : <IntlMsg {...messages.otherContactsShow} values={{ count: contacts.length }} />}
      </SecondaryButton>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <Box id={listId} mt={1}>
          <ContactSummaryList contacts={contacts} />
        </Box>
      </Collapse>
    </Box>
  );
};
